import React from 'react';
import styled from 'styled-components';

const PesquisaContainer = styled.div`
  border: 1px solid #bdbdbd;
  border-radius: 24px;
  padding: 0 15px;
  background: #fff;
  display: flex;
  align-items: center;
  width: 100%;
  height: 44px;
  box-sizing: border-box;
`;

const Input = styled.input`
  border: none;
  background: transparent;
  outline: none;
  font-family: 'Roboto', sans-serif;
  font-size: 15px;
  color: #222;
  width: 100%;
`;

const Icon = styled.span`
  display: flex;
  align-items: center;
  margin-left: 8px;
  color: #8e8e93;
`;

const CampoPesquisa = ({ value, onChange, placeholder }) => (
  <PesquisaContainer>
    <Input
      type="text"
      value={value}
      onChange={onChange}
      placeholder={placeholder || 'Pesquisar'}
    />
    <Icon>
      <svg width="22" height="22" fill="none" stroke="#8e8e93" strokeWidth="2" viewBox="0 0 24 24">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
    </Icon>
  </PesquisaContainer>
);

export default CampoPesquisa;